import { ActionTypes } from 'src/types/types';

export const FEATURE_NAME = 'eventsFilters';
export const actionTypes = {
  FETCH_FILTERS_VALUES: `${FEATURE_NAME}/FETCH_FILTERS_VALUES`,
} satisfies ActionTypes<typeof FEATURE_NAME>;
